import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { compose, find, pathOr } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { saveSetting } from 'features/views/settings/actions';
import { getTaskFilters } from 'features/views/settings/selectors';
import { getCodelistPropById } from 'utils';

import InformationSettingSwitch from './InformationSettingSwitch';

export const ListItemSubFilters = ({ subFilters, taskSubtypesCodelist }) => {
	const dispatch = useDispatch();

	const taskFilters = useSelector(getTaskFilters);

	const pickSubFilterStateCheckedValue = (taskTypeId, filterId, taskFilters) => {
		return compose(
			pathOr(null, ['enabled']),
			find((filter) => filter.id === filterId),
			pathOr(null, ['subTypes']),
			find((filter) => filter.taskTypeId === taskTypeId),
		)(taskFilters);
	};

	const sortTaskFilterIds = (a, b, taskSubtypesCodelist) => {
		const aTaskTypeDescription = getCodelistPropById(a.taskSubtypeId, taskSubtypesCodelist, 'description');
		const bTaskTypeDescription = getCodelistPropById(b.taskSubtypeId, taskSubtypesCodelist, 'description');
		return aTaskTypeDescription.localeCompare(bTaskTypeDescription);
	};

	const getFilterName = (taskSubtypeId, taskSubtypesCodelist) => {
		return getCodelistPropById(taskSubtypeId, taskSubtypesCodelist, 'description');
	};

	const handleCheckFilter = useCallback(
		(filter) => () => {
			dispatch(saveSetting(filter));
		},
		[dispatch],
	);

	return (
		<Box sx={{ ml: 7, mb: 2 }}>
			{subFilters
				.sort((a, b) => sortTaskFilterIds(a, b, taskSubtypesCodelist))
				.map((filter) => (
					<InformationSettingSwitch
						key={filter.id}
						value={pickSubFilterStateCheckedValue(filter.taskTypeId, filter.id, taskFilters)}
						onChange={handleCheckFilter(filter)}
						description={getFilterName(filter.taskSubtypeId, taskSubtypesCodelist)}
					/>
				))}
		</Box>
	);
};

ListItemSubFilters.propTypes = {
	subFilters: PropTypes.arrayOf(PropTypes.object),
	taskSubtypesCodelist: PropTypes.arrayOf(PropTypes.object),
};

export default ListItemSubFilters;
